import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/products");

export const Route = createFileRoute("/products")({
  head: () => ({
    meta: [
      { title: "Products — LevelLoad" },
      { name: "description", content: "Products — LevelLoad transport planning." },
      { property: "og:title", content: "Products — LevelLoad" },
      { property: "og:description", content: "Products — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
